import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage } from '../slices/filtersSlice';
const Pagination = ({ pageCount }) => {
    const dispatch = useDispatch();
    const currentPage = useSelector((state) => state.filters.currentPage);
    const incHandler = () => {
        if (currentPage !== pageCount) {
            dispatch(setCurrentPage(currentPage + 1));
        }
    };
    const decHandler = () => {
        if (currentPage !== 1) {
            dispatch(setCurrentPage(currentPage - 1));
        }
    };
    return (_jsx("div", { children: _jsxs("ul", Object.assign({ className: "pagination" }, { children: [_jsx("li", Object.assign({ className: currentPage === 1 ? 'inactive' : '', onClick: decHandler }, { children: '<' })), Array(pageCount).fill(1).map((page, i) => _jsx("li", Object.assign({ className: currentPage === i + 1 ? 'active' : '', onClick: () => dispatch(setCurrentPage(i + 1)) }, { children: i + 1 }), i)), _jsx("li", Object.assign({ className: currentPage === pageCount ? 'inactive' : '', onClick: incHandler }, { children: '>' }))] })) }));
};
export default Pagination;
